import React from 'react';
import axios from 'axios';
import { Radio, Checkbox, Form, Row, Col, message, Input, Table } from 'antd';
import withSpin from 'components/withSpin';
import SaveButton from 'components/SaveButton';
import stickyError from 'components/stickyError';

import apiPath from 'apiPath';

class AdmitStatus extends React.Component {
    state = {
        admitStatus: [],
        shipStatus: [],
        value: [],
        conditionVisibile: false,
        discipChecked: null,
        acadChecked: null,
        transChecked: null,
        ConditionalDiscip: false,
        ConditionalAcad: false,
        ConditionalTrans: false,
        noteInfo: []
    }

    //Handle Submit to get all the form data and post it 
    handleSubmit = (event) => {
        event.preventDefault();
        this.props.isSubmitting();
        this.props.form.validateFields((err, values) => {
            this.onCondChange(event);
            this.getAdmitStatus();
        })
    }

    //Get's admit status.  First part builds a new object to place in the notes section.  Takes 1's and 0's and converts them to string "conditional academic" or "conditional discipline" to display in table
    getAdmitStatus = () => {
        axios.get(apiPath + '/admissions/getAdmitStatus', { withCredentials: true }).then(result => {
            let noteInfo = result.data.map(a => {
                const status = []
                if (a.ConditionalAcad === "1") {
                    a.ConditionalAcad = "Conditional Academic"
                    status.push(a.ConditionalAcad)

                } else {
                    a.ConditionalAcad = ""

                }
                if (a.ConditionalDiscip === "1") {
                    a.ConditionalDiscip = "Conditional Discipline"
                    status.push(a.ConditionalDiscip)

                } else {
                    a.ConditionalDiscip = ""

                }
                if (a.ConditionalTrans === "1") {
                    a.ConditionalTrans = "Conditional Transcript"
                    status.push(a.ConditionalTrans)

                } else {
                    a.ConditionalTrans = ""

                }
                if (a.FullAdmit === "1") {
                    a.FullAdmit = "Full Admit"
                    status.push(a.FullAdmit)

                } else {
                    a.FullAdmit = ""

                }
                a.Status = status.join(', ')
                return a
            })

            this.setState({ noteInfo })
            if (result.data[0] === undefined) {
                console.log('**No data available**')
            } else {
                if (result.data[0].FullAdmit === "1" || result.data[0].FullAdmit === "Full Admit") {
                    this.setState({ value: 2 })
                } else {
                    this.setState({ value: 1, conditionVisibile: true })
                }
                if (result.data[0].ConditionalAcad === "Conditional Academic" || result.data[0].ConditionalAcad === "1") {
                    this.setState({ acadChecked: true })
                } else {
                    this.setState({ acadChecked: false })
                }
                if (result.data[0].ConditionalDiscip === "Conditional Discipline" || result.data[0].ConditionalDiscip === "1") {
                    this.setState({ discipChecked: true })
                } else {
                    this.setState({ discipChecked: false })
                }
                if (result.data[0].ConditionalTrans === "Conditional Transcript" || result.data[0].ConditionalTrans === "1") {
                    this.setState({ transChecked: true })
                } else {
                    this.setState({ transChecked: false })
                }
            }
        })
    }

    //Post admit status from checkboxes and note as well
    onChange = (e) => {
        this.setState({
            value: e.target.value,
        })
        if (e.target.value === 1) {
            this.setState({ conditionVisibile: true, })
        } else if (e.target.value === 2) {
            axios.post(apiPath + '/admissions/postAdmitStatus', { FullAdmit: 1, ConditionalDiscip: 0, ConditionalAcad: 0, ConditionalTrans: 0, Note: "Full Admit" }, { withCredentials: true }).then(result => {
                this.setState({ conditionVisibile: false })
            })
            this.setState({ conditionVisibile: false })
        }
    }

    onCondChange = (event) => {
        this.props.form.validateFields((errors, values) => {
            if (values.Note === "" || (values.ConditionalAcad === false && values.ConditionalDiscip === false && values.ConditionalTrans === false)) {
                return stickyError('Must Enter Note and check a conditional status type.');
            } else {
                axios.post(apiPath + '/admissions/postAdmitStatus', { FullAdmit: 0, ConditionalDiscip: (values.ConditionalDiscip === null) ? '' : values.ConditionalDiscip, ConditionalAcad: (values.ConditionalAcad === null) ? '' : values.ConditionalAcad, ConditionalTrans: (values.ConditionalTrans === null) ? '' : values.ConditionalTrans, Note: values.Note }, { withCredentials: true }).then(response => {
                    this.setState({ acadChecked: values.ConditionalAcad, discipChecked: values.ConditionalDiscip, transChecked: values.ConditionalTrans });
                    message.success('Saved!');
                })
            }
        })
    }

    acadChecked = (event) => {
        this.setState({ acadChecked: event.target.checked });
    }

    discipChecked = (event) => {
        this.setState({ discipChecked: event.target.checked });
    }

    transChecked = (event) => {
        this.setState({ transChecked: event.target.checked });
    }



    componentDidMount() {
        this.getAdmitStatus();
    }

    render() {
        const { TextArea } = Input;
        const RadioGroup = Radio.Group;
        const { getFieldDecorator, disabled } = this.props.form;

        return (

            <div>
                {this.props.isStudent &&
                    <Form onSubmit={this.handleSubmit}>
                        <Form.Item>
                            <RadioGroup defaultValue="" onChange={this.onChange} value={this.state.value}>
                                <p>Is this student an Full or Conditional Admit?</p>
                                <Radio value={1}>Conditional Admit</Radio>
                                <Radio value={2}>Full Admit</Radio>
                            </RadioGroup>
                        </Form.Item>
                        <span style={{ visibility: this.state.conditionVisibile ? 'visible' : 'hidden' }}>
                            <Row type="flex" justify="start">
                                <Col>
                                    <Form.Item>
                                        {getFieldDecorator('ConditionalDiscip', {
                                            initialValue: this.state.discipChecked
                                        })(
                                            <Checkbox checked={this.state.discipChecked} onChange={this.discipChecked}>Conditional Discipline</Checkbox>
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col>
                                    <Form.Item>
                                        {getFieldDecorator('ConditionalAcad', {
                                            initialValue: this.state.acadChecked
                                        })(
                                            <Checkbox checked={this.state.acadChecked} onChange={this.acadChecked}>Conditional Academic</Checkbox>
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col>
                                    <Form.Item>
                                        {getFieldDecorator('ConditionalTrans', {
                                            initialValue: this.state.transChecked
                                        })(
                                            <Checkbox checked={this.state.transChecked} onChange={this.transChecked}>Conditional Transcript</Checkbox>
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item>
                                        {getFieldDecorator('Note', {
                                            initialValue: (this.state.noteInfo[0] === undefined) ? '' : this.state.noteInfo[0].Note
                                        })(
                                            <TextArea />
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                            <br />
                            <Form.Item>
                                <SaveButton
                                    disabled={!this.props.form.isFieldsTouched()}
                                />
                            </Form.Item>
                            <br />
                            <br />
                            <Table
                                rowKey={'StatusDate'}
                                columns={[
                                    { title: 'Status', dataIndex: 'Status' },
                                    { title: 'Note', dataIndex: 'Note' },
                                    { title: 'Date', dataIndex: 'StatusDate' }
                                ]}
                                bordered={true}
                                style={{ backgroundColor: 'white', marginTop: '20px' }}
                                pagination={false}
                                dataSource={this.state.noteInfo.map(note => {
                                    return note
                                })} />
                        </span>
                    </Form>
                }
            </div>
        );
    }
}

export default withSpin(Form.create()(AdmitStatus));



// WEBPACK FOOTER //
// ./portal-components/Portal/Admissions/AdmitStatus.jsx